import { icon } from '../../common/react/Icons';

export const Icons = {

    NotificationCenterLightWithUnseenNotifications: icon({
      name: 'notificationCenterIcon',
      img: 'user_notifications_icon_unseen_items_light.svg',
      hoverImg: 'user_notifications_icon_unseen_items_light_active.svg',
      size: 'large',
    }),

    NotificationCenterLight: icon({
      name: 'notificationCenterIcon',
      img: 'user_notifications_icon_light.svg',
      hoverImg: 'user_notifications_icon_light_active.svg',
      size: 'large',
    }),

    NotificationCenterWithUnseenNotifications: icon({
      name: 'notificationCenterIcon',
      img: 'user_notifications_icon_unseen_items.svg',
      hoverImg: 'user_notifications_icon_unseen_items_active.svg',
      size: 'large',
    }),

    NotificationCenter: icon({
      name: 'notificationCenterIcon',
      img: 'user_notifications_icon.svg',
      hoverImg: 'user_notifications_icon_active.svg',
      size: 'large',
    }),

    NotificationActionsMenu: icon({
      name: 'notificationActionIcon',
      img: 'actions_hover.svg',
      size: 'small',
    })
};